// @flow
import React from 'react'
import ComplementaryButton from '../buttons/complementary-button'
import CardHeader from './card-header'
import BidStateTag from '../tags/bid-state-tag'
import AuctionStateTag from '../tags/auction-state-tag'
import CardBodyAuction from './card-body-auction'
import CardBodyCharity from './card-body-charity'
import CardBodyItem from './card-body-item'
import withEntity from '../../context/with-entity'
import { domains } from '../../services'
import { AUCTION_STATE } from '../../services/auction/constants'

const renderCardBody = (domain, entity) => {
  switch (domain) {
    case domains.CHARITIES:
      return <CardBodyCharity charity={entity} />
    case domains.AUCTIONS:
      return <CardBodyAuction auction={entity} />
    case domains.ITEMS:
      return <CardBodyItem item={entity} />
    default:
      break
  }
}

type CardProps = {
  id: number,
  domain: 'charities' | 'auctions' | 'items',
  entity: Object,
  isLoading: boolean,
  userId: string
}

export const Card = (props: CardProps) => {
  const { entity, domain, id, isLoading, userId } = props
  return (
    <div className='card-wrapper'>
      <div className='card'>
        <CardHeader
          photo={
            entity.photo ||
            (Array.isArray(entity.media) ? entity.media[0] : null)
          }
        />
        {domain === domains.ITEMS && entity.auction.state !== 'pending' ? (
          <div className='push-top-tag'>
            {!isLoading &&
            entity.auction.state === AUCTION_STATE.LIVE &&
            userId &&
            entity.bids.length &&
            entity.bids.find(bid => bid && bid.userId === userId) ? (
              <BidStateTag bidState={entity.bidState} />
            ) : (
              <AuctionStateTag auctionState={entity.auction.state} />
            )}
          </div>
        ) : null}
        {renderCardBody(domain, entity)}
      </div>
      <footer className='card-footer'>
        <ComplementaryButton
          hasIcon
          iconName='plus'
          text='view details'
          domain={domain}
          id={id}
        />
      </footer>
    </div>
  )
}

export default withEntity(Card)



// WEBPACK FOOTER //
// ./src/ui/cards/card.js